<template>
    <div id="delete-email-template-modal" class="modal fade" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
                    <h4 class="modal-title">DELETE TEMPLATE</h4>
                </div>
                <div class="modal-body">
                    Are you sure you would like to delete this Template?
                </div>
                <div class="modal-footer">
                    <button class="btn green mt-ladda-btn ladda-button delete-btn" @click.prevent="runDelete"
                            data-style="expand-left">
                        <span class="ladda-label">Yes</span>
                    </button>
                    <button type="button" data-dismiss="modal" aria-hidden="true" class="btn default"> Cancel</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import Vue from "vue";

    export default {

        props: ['deleteTemplateId'],
        data() {
            return {
                duplicateName: '',
                show: false,
            }
        },

        computed: {
            ...mapGetters({
                'errors': 'emails/getErrors'
            })
        },

        mounted() {
            $('#delete-email-template-modal').modal('show');
            $('#delete-email-template-modal').on('hidden.bs.modal', () => {
                this.$emit('hide');
            });
        },

        methods: {
            ...mapActions('emails', [
                'deleteTemplate'
            ]),

            runDelete() {
                this.button = Ladda.create(document.querySelector('.delete-btn'));
                this.button.start();

                this.deleteTemplate({
                    template_id: this.deleteTemplateId
                }).then(() => {
                    this.button.stop();
                    $('#delete-email-template-modal').modal('hide');

                    if (!this.errors.deletingTemplate) {
                        this.$emit('delete-success');
                    } else {
                        this.$notify({type: 'error', text: 'Deleting template failed!'});
                    }
                });
            }
        },
    }
</script>



// WEBPACK FOOTER //
// DeleteTemplateModal.vue?37b99017